<form name="form" class="page-fix-accessibility-form" #form="ngForm">
    <page-fix-form-wizard-container (dismiss)="dismiss.emit()"
                                    (close)="closeModal($event.pageFix)"
                                    [formValid]="!!form.valid && customValidation"
                                    [pageFixApplied]="!!pageFix"
                                    [pageFix]="pageFix">
        <page-fix-form-info-view [monType]="infoViewType"
                                 [monName]="infoViewName"
                                 [monSelected]="!pageFix"
                                 [monTitle]="'Info'"
                                 [monOrder]="0"
                                 [monFooter]="infoFooter">
            <img-slot>
                <img class="img-responsive image-sample inline-block"
                     src="/images/page-fix/design/italic-tag.png"
                     [attr.alt]="'Replace Italic element with EM' | translate"/>
            </img-slot>
            <txt-slot>
                <h2 translate>What is wrong with the &lt;i&gt; (italic) element?</h2>
                <p translate>
                    Italics are often used in HTML to put emphasis on text. However, this is often achieved with the &lt;I&gt; tag, in which case the emphasis is not announced by screen readers. Using the &lt;I&gt; tag doesn't provide enough context and is becoming an outdated practice.
                </p>
                <h3 translate>And how are we going to fix it?</h3>
                <p translate>
                    There's only one way of doing this. Acquia Web Governance will replace all the &lt;I&gt; tags it can find on your website with em tags instead.
                </p>
            </txt-slot>
        </page-fix-form-info-view>
        <page-fix-form-italic-options [monPageFix]="pageFix"
                                      [monPageFixId]="pageFixId"
                                      [monPageFixSelector]="pageFixSelector"
                                      [monType]="optionsViewType"
                                      [monName]="optionsViewName"
                                      [monSelected]="!!pageFix"
                                      [monFooter]="optionsFooter"
                                      [monTitle]="'Options' | translate"
                                      [monOrder]="1">
        </page-fix-form-italic-options>
        <page-fix-form-info-view [monType]="testingViewType"
                                 [monName]="testingViewName"
                                 [monTitle]="'Testing' | translate"
                                 [monOrder]="2"
                                 [monFooter]="testingFooter">
            <img-slot>
                <img class="img-responsive image-sample inline-block"
                     src="/images/page-fix/design/italic-tag-test.png"
                     [attr.alt]="'Replace Italic element with EM' | translate"/>
            </img-slot>
            <txt-slot>
                <h2 translate>Potential problems that can arise</h2>
                <p translate>
                    In the end both &lt;i&gt; and &lt;em&gt; tags look visually the same. However, they each have a different semantic meaning. &lt;em&gt; is used to represent emphasis, while &lt;i&gt; tag represents a word or a sentence that the user might want to set in italic (a foreign word, definition of a word, etc.). For the latter CSS should be used instead.
                </p>
                <h3 translate>&lt;i&gt; tags as icons</h3>
                <p translate>
                    The biggest problem with this fix can arise if the &lt;i&gt; tag is used for icons instead of, for instance, &lt;span&gt; (example: Font Awesome). If you notice that something looks wrong with your icons after applying the fix, this might be the reason. However, &lt;i&gt; tags for icons tend to use a class so make sure you have set the options to only alter the tags without altering the classes. That way your icons should be left untouched.
                </p>
            </txt-slot>
        </page-fix-form-info-view>
    </page-fix-form-wizard-container>
</form>
